module.exports = __webpack_public_path__ + "static/media/cert_128.d891f0d2.jpg";